import { selectMatches } from "selectors/Match";
import { MatchesViewerMatch } from "./MatchesViewerMatch";
import { useAppSelector } from "app/hooks";
import { PanelList } from "components/PanelList/PanelList";

interface Props {
  matchIds: string[];
  tournamentId: string;
  hoverColor?: string;
}

export const MatchesViewer = ({
  matchIds,
  tournamentId,
  hoverColor,
}: Props) => {
  const matches = useAppSelector((state) => selectMatches(state, matchIds));
  const sortedMatches = matches.sort((a, b) => a.startTimeMs - b.startTimeMs);

  return (
    <PanelList hoverColor={hoverColor}>
      {sortedMatches.map((m) => (
        <MatchesViewerMatch key={m.id} match={m} tournamentId={tournamentId} />
      ))}
    </PanelList>
  );
};
